export const CHECKOUT_FORM_DEFAULT_STATE = {
  avsResultCode: 'M',
  cvvResultCode: 'M',
  cavvResultCode: '2',
  billingFirstName: '',
  billingLastName: '',
  billingAddressLine1: '',
  billingAddressLine2: '',
  billingCity: '',
  state: '',
  billingZip: '',
  billingCountry: '',
  phone: '',
  email: '',
  cardName: '',
  cardNumber: '',
  expirationYear: '',
  expirationMonth: '',
  cvv: '',
  payeeName: '',
  mcc: '',
  payeeType: '',
  appKey: '',
  appSecret: '',
  spreedlyKey: '',
  responseCode: '202',
  idempotencyKey: '',
  amount: '',
  status: '',
  transactionType: '',
  gatewaySource: 'nmi',
  flexChargeTerms: true,
  successUrl: '',
  rejectUrl: '',
  cancelUrl: '',
  closeLoaderCallback: false,
  openLoaderCallback: false,
  useSale: false,
  isAsynchronous: true,
  withEvaluate: true,
  evaluatePayload: '',
  subscriptionId: '',
  subscriptionInterval: 'monthly',
  paymentNumber: '',
  currency: 'USD',
};

export const CHECKOUT_FORM_DEMO_DEFAULT_STATE = {
  ...CHECKOUT_FORM_DEFAULT_STATE,
  billingFirstName: 'NANCY',
  billingLastName: 'BIRKHEAD',
  billingAddressLine1: '378 EAST ST',
  billingCity: 'BLOOMSBURG',
  state: 'PA',
  billingZip: '178151847',
  billingCountry: 'US',
  phone: '5032219597',
  email: 'test@gmail.com',
  cardName: 'NANCY BIRKHEAD',
  cardNumber: '4111111111111111',
  expirationYear: '2033',
  expirationMonth: '10',
  cvv: '999',
};

export const CHECKOUT_FORM_DEMO_CHALLENGE_SUCCESS_DEFAULT_STATE = {
  ...CHECKOUT_FORM_DEMO_DEFAULT_STATE,
  billingFirstName: 'Cure',
  billingLastName: 'Tester',
  phone: '+99.0007',
};

export const CHECKOUT_FORM_DEMO_CHALLENGE_DECLINE_DEFAULT_STATE = {
  ...CHECKOUT_FORM_DEMO_CHALLENGE_SUCCESS_DEFAULT_STATE,
  phone: '+99.9995',
};

export const FORM_FIELDS: {
  [key: string]: {
    sm: number;
    name: string;
    label: string;
    saveInStorage: boolean;
    required: boolean;
    autoComplete: string;
    inputProps?: any;
    helperText?: string;
  }[];
} = {
  address: [
    {
      sm: 6,
      name: 'billingFirstName',
      label: 'First name',
      saveInStorage: false,
      required: true,
      autoComplete: 'given-name',
    },
    {
      sm: 6,
      name: 'billingLastName',
      label: 'Last name',
      saveInStorage: false,
      required: true,
      autoComplete: 'family-name',
    },
    {
      sm: 12,
      name: 'billingAddressLine1',
      label: 'Address line 1',
      saveInStorage: false,
      required: true,
      autoComplete: 'billing address-line1',
    },
    {
      sm: 12,
      name: 'billingAddressLine2',
      label: 'Address line 2',
      saveInStorage: false,
      required: false,
      autoComplete: 'billing address-line2',
    },
    {
      sm: 6,
      name: 'billingCity',
      label: 'City',
      saveInStorage: false,
      required: true,
      autoComplete: 'billing address-level2',
    },
    {
      sm: 6,
      name: 'state',
      label: 'State/Province/Region',
      saveInStorage: false,
      required: true,
      autoComplete: 'billing address-level1',
      inputProps: { style: { textTransform: 'uppercase' } },
    },
    {
      sm: 6,
      name: 'billingZip',
      label: 'Zip / Postal code',
      saveInStorage: false,
      required: true,
      autoComplete: 'billing postal-code',
    },
    {
      sm: 6,
      name: 'billingCountry',
      label: 'Country',
      saveInStorage: false,
      required: true,
      inputProps: { minLength: 3, maxLength: 3, style: { textTransform: 'uppercase' } },
      autoComplete: 'billing country',
    },
    {
      sm: 6,
      name: 'phone',
      label: 'Phone number',
      saveInStorage: false,
      required: true,
      autoComplete: 'billing phone',
    },
    {
      sm: 6,
      name: 'email',
      label: 'email',
      saveInStorage: false,
      required: true,
      autoComplete: 'email',
    },
  ],

  paymentMethod: [
    {
      sm: 12,
      name: 'cardName',
      label: 'Name on card',
      saveInStorage: false,
      required: true,
      autoComplete: 'cc-name',
    },
    {
      sm: 12,
      name: 'cardNumber',
      label: 'Card number',
      saveInStorage: false,
      required: true,
      autoComplete: 'cc-number',
    },
    {
      sm: 4,
      name: 'expirationMonth',
      label: 'Expiry month',
      saveInStorage: false,
      required: true,
      autoComplete: 'cc-exp-month',
    },
    {
      sm: 4,
      name: 'expirationYear',
      label: 'Expiry year',
      saveInStorage: false,
      required: true,
      autoComplete: 'cc-exp-year',
    },
    {
      sm: 4,
      name: 'cvv',
      label: 'CVV',
      saveInStorage: false,
      required: true,
      autoComplete: 'cvv',
      helperText: 'Last three digits on signature strip',
    },
  ],

  payee: [
    {
      sm: 6,
      name: 'payeeName',
      label: 'Country',
      saveInStorage: false,
      required: false,
      autoComplete: 'payeeName',
    },
    {
      sm: 6,
      name: 'mcc',
      label: 'mcc',
      saveInStorage: false,
      required: false,
      autoComplete: 'mcc',
    },
    {
      sm: 6,
      name: 'payeeType',
      label: 'payeeType',
      saveInStorage: false,
      required: false,
      autoComplete: 'payee-type',
    },
  ],

  identification: [
    {
      sm: 6,
      name: 'mid',
      label: 'Merchant Id',
      saveInStorage: true,
      required: true,
      autoComplete: 'mid',
    },
    {
      sm: 6,
      name: 'siteId',
      label: 'Site Id',
      saveInStorage: true,
      required: true,
      autoComplete: 'siteId',
    },
    {
      sm: 6,
      name: 'appKey',
      label: 'App key',
      saveInStorage: true,
      required: true,
      autoComplete: 'appKey',
    },
    {
      sm: 6,
      name: 'appSecret',
      label: 'App secret',
      saveInStorage: true,
      required: true,
      autoComplete: 'appSecret',
    },
    {
      sm: 6,
      name: 'spreedlyKey',
      label: 'Spreedly environment key',
      saveInStorage: true,
      required: true,
      autoComplete: 'spreedlyKey',
    },
  ],

  transaction: [
    {
      sm: 12,
      name: 'gatewaySource',
      label: 'Gateway source',
      saveInStorage: false,
      required: false,
      autoComplete: 'gatewaySource',
    },
    // {
    //   sm: 12,
    //   name: 'responseCode',
    //   label: 'Response code',
    //   saveInStorage: false,
    //   required: false,
    //   autoComplete: 'responseCode',
    // },
    {
      sm: 12,
      name: 'idempotencyKey',
      label: 'Idempotency key',
      saveInStorage: false,
      required: false,
      autoComplete: 'idempotencyKey',
    },
    {
      sm: 6,
      name: 'transactionAmount',
      label: 'Amount',
      saveInStorage: false,
      required: true,
      autoComplete: 'transactionAmount',
    },
    {
      sm: 6,
      name: 'status',
      label: 'Status',
      saveInStorage: false,
      required: false,
      autoComplete: 'status',
    },
    {
      sm: 6,
      name: 'transactionType',
      label: 'Transaction Type',
      saveInStorage: false,
      required: false,
      autoComplete: 'transactionType',
    },
    {
      sm: 6,
      name: 'avsResultCode',
      label: 'AVS Result',
      saveInStorage: false,
      required: false,
      autoComplete: 'avsResultCode',
    },
    {
      sm: 6,
      name: 'cvvResultCode',
      label: 'CVV Result',
      saveInStorage: false,
      required: false,
      autoComplete: 'cvvResultCode',
    },
    {
      sm: 6,
      name: 'cavvResultCode',
      label: 'cavvResultCode',
      saveInStorage: false,
      required: false,
      autoComplete: 'cavvResultCode',
    },
  ],
  urls: [
    {
      sm: 6,
      name: 'successUrl',
      label: 'Success URL',
      saveInStorage: false,
      required: false,
      autoComplete: 'successUrl',
    },
    {
      sm: 6,
      name: 'rejectUrl',
      label: 'Decline URL',
      saveInStorage: false,
      required: false,
      autoComplete: 'rejectUrl',
    },
    {
      sm: 6,
      name: 'cancelUrl',
      label: 'Cancel URL',
      saveInStorage: false,
      required: false,
      autoComplete: 'cancelUrl',
    },
  ],

  evaluate: [
    {
      sm: 12,
      name: 'evaluatePayload',
      label: 'Evaluate payload',
      saveInStorage: false,
      required: false,
      autoComplete: 'evaluatePayload',
    },
  ],

  dev: [
    {
      sm: 6,
      name: 'DynamicDescriptor',
      label: 'Dynamic Descriptor',
      saveInStorage: true,
      required: false,
      autoComplete: 'DynamicDescriptor',
    },
    {
      sm: 6,
      name: 'payerId',
      label: 'Payer Id',
      saveInStorage: true,
      required: false,
      autoComplete: 'payerId',
    },
  ],
  development: [
    {
      sm: 6,
      name: 'subscriptionId',
      label: 'Subscription Id',
      saveInStorage: true,
      required: false,
      autoComplete: 'subscriptionId',
    },
    {
      sm: 6,
      name: 'subscriptionInterval',
      label: 'Subscription Interval',
      saveInStorage: true,
      required: false,
      autoComplete: 'subscriptionInterval',
    },
    {
      sm: 6,
      name: 'paymentNumber',
      label: 'Payment Number',
      saveInStorage: true,
      required: false,
      autoComplete: 'paymentNumber',
    },
  ],
};
